import styled from "styled-components"

import { Link } from "gatsby"

const ReadLink = styled(Link)`
  display: inline-block;
  font-size: 0.875rem;
`
export default ReadLink
